'use client'
import {ReactNode, useRef, useState, useEffect} from 'react';
import {EngineMain} from "../assets/js/engines/engine.js"
import {EngineWebGPU} from "../assets/js/engines/engine_wgpu.js"

import Ammo from "../assets/js/builds/ammo.js"
import {ScreenChange} from '../lib/game.ts'
import {ANCHOR, BC_SOLANA, BlockchainInfos, getUserBalance, getUserInfos, globalUserInfos, PHANTOM} from '../lib/blockchainSession.ts'


import {initanchor, initwax} from '../lib/actionsWax'
import {initPhantom, initsolana} from '../lib/actionsSol.ts'
import { GameConfig, GameStats, TrackInfo } from '../lib/definitions';
import Loading from './loading.tsx';
import EngineConfig from './engineconfig';
import NavBarBalance, { ActiveNavLink } from './balance.tsx';
import GameStatsTable from './GameStatsTable.tsx';

    var engine : any = null;
    var engineWebGPU: any= null;
    var curEngine: any = null;
    var renderMode = 0;

    function defHandler(e: any){ return true;}
     const domEvents = {    onMouseMove : defHandler, 
                            onMouseDown: defHandler, 
                            onMouseUp: defHandler, 
                            onTouchStart: defHandler, 
                            onTouchMove: defHandler, 
                            onTouchEnd: defHandler, 
                            onKeyDown: defHandler, 
                            onKeyUp: defHandler
                        }

    function onMouseMove(e:any) 
    { 
        if(domEvents.onMouseMove)
            domEvents.onMouseMove(e)
        
    }
    function onMouseDown(e:any) 
    { 
        if(domEvents.onMouseDown)
            domEvents.onMouseDown(e)
    }
    function onMouseUp(e:any) 
    { 
        if(domEvents.onMouseUp)
            domEvents.onMouseUp(e)
    }
    function onTouchStart(e:any) 
    { 
        if(domEvents.onTouchStart)
            domEvents.onTouchStart(e)
    }
    function onTouchMove(e:any) 
    { 
        if(domEvents.onTouchMove)
            domEvents.onTouchMove(e)    
    }
    function onTouchEnd(e:any) 
    { 
        if(domEvents.onTouchEnd)
            domEvents.onTouchEnd(e)    
        
    }

    function onKeyDown(e:any) 
    { 
        if(domEvents.onKeyDown)
            domEvents.onKeyDown(e)
    }
    function onKeyUp(e:any) 
    { 
        if(domEvents.onKeyUp)
            domEvents.onKeyUp(e)
    }

    type GameGLProp = {
        blockchaininfos: BlockchainInfos
        tracks:Array<TrackInfo>
        gameConfig : GameConfig;

    }

    type setActiveLnks = (activeLinks:ActiveNavLink) => void;
    
    let loaded = false;
    let screenChanger:ScreenChange | null = null;

    //new BlockChainSession(props.account, props.logType, props.carid, props.cartype, props.network, props.testnet, props.mainContract, props.AA, props.SA, props.MX, props.TK, props.garage_seed, props.GameKey, props.mintKey, props.nitros_seed, props.cfg_seed)
const GameGL = (props: GameGLProp):ReactNode =>{
        
        let endpoint = 0;
        let selectedEngine = 0;
        const endPoints = props.blockchaininfos.endpoints;
        
        try{
            const endpointSt = localStorage.getItem('endpoint');
            if (endpointSt !== null) {
                for (let n = 0; n < endPoints.length; n++) {
                    if (endPoints[n] === endpointSt) {
                        endpoint = n;
                    }
                }
            } else {
                localStorage.setItem('endpoint', endPoints[0]);
            }


            const lst = localStorage.getItem('engine')
            selectedEngine = lst ? parseInt(lst) : 0;
        }
        catch(e){}
        const endpointURL = endPoints[endpoint];
        const glDomRef = useRef<HTMLDivElement> (null);


        const [activeLinks, setactiveLinks] = useState<ActiveNavLink>({selectCar:true, play:false, lobby:false, restart:false, garage:true});
        const [blockchaininfos, setBCInfos] = useState(props.blockchaininfos);
        const [gUserInfos, setGuserInfos] = useState<globalUserInfos>({balance: {stl:"0", main:"0"}, userInfos:{techBalance: 0.0, nitros:0.0, quests: 0.0, bluePrints:0.0}})
        const [isLoading, setLoading] = useState(true)

        const [gameStats, setgameStats] = useState<Array<GameStats> | null>(null)
        const [totalBonus, settotalBonus] = useState<number>(0)

        if(blockchaininfos.bc_type == BC_SOLANA){
            initsolana(endpointURL);

            if(blockchaininfos.logType == PHANTOM)
                initPhantom()
            
        }else{
            initwax(endpointURL, blockchaininfos.AA.contract);

            if(blockchaininfos.logType == ANCHOR)
                initanchor(endpointURL, blockchaininfos.chainId);
        }


        if(typeof window !== "undefined" && curEngine === null){
            if(selectedEngine == 2) {

                if(engineWebGPU === null)
                {
                        try{
                            engineWebGPU = new EngineWebGPU(true);
                        
                        }
                        catch(e:any)
                        {
                            alert('unable to init wengpu '+e.message);
                        }
                }

                curEngine = engineWebGPU;
                renderMode = 2;
            } else {

                if(!engine) {
                    try {
                        engine = new EngineMain(true, props.blockchaininfos.baseAddr);
                
                    } catch(e:any) {
                        console.error('unable to init threejs '+e.message);
                    }
                }
                    
                curEngine = engine;
                renderMode = 0;
            }
        }
        
       
        useEffect(() => {
            curEngine.init().then(() =>{
                getUserInfos(blockchaininfos).then((infos) => {

                    getUserBalance(blockchaininfos).then((balance) =>{

                        infos = infos ? infos:{techBalance:0.0, bluePrints:0.0, nitros:0.0, quests:0.0};

                        setGuserInfos({balance:balance, userInfos:infos});
                        setLoading(false)
                    });
                })
            });
        }, [blockchaininfos])



        if(isLoading) return <Loading />

        if(!loaded){
            curEngine.enableCameraAnchor(true);
            curEngine.initEngineUI();
            curEngine.initControllers();
            curEngine.startAccel();
       
            /*
            if(curEngine)
                curEngine.enableRender(false);
            */
        

            Ammo().then((a:any)=>{

                screenChanger = new ScreenChange(curEngine, renderMode, a, glDomRef, domEvents, blockchaininfos, props.gameConfig, setactiveLinks, setGuserInfos, setBCInfos, setgameStats, settotalBonus);
                screenChanger.lobby.setTracks(props.tracks);

                screenChanger.current = screenChanger.lobby;
                const lastScreen= localStorage.getItem("lastScreen");

            if(!screenChanger)
                    return;

                if(renderMode === 0)
                    screenChanger.current?.initEngine();
                else if(renderMode === 2)
                    screenChanger.current?.initEngineWebGPU();


                if(!screenChanger)
                    return;

                if((lastScreen == null)||(lastScreen == "lobby")){
                    screenChanger.lobby.load().then(()=>{
                        if(!screenChanger)
                            return;

                        if(gUserInfos && gUserInfos.userInfos)
                            screenChanger.lobby.setUserInfos(gUserInfos, props.gameConfig);

                        screenChanger.lobby.start();
                        screenChanger.current=screenChanger.lobby;
                    });
                }
                if(lastScreen == "play"){

                    screenChanger.play.load().then((res: boolean)=>{
                        if(res === true){

                            if(!screenChanger)
                                return;

                            screenChanger.play.setUserInfos(gUserInfos, props.gameConfig);
                            screenChanger.play.start();
                            screenChanger.current=screenChanger.play;
                        }else{
                            localStorage.setItem("lastScreen", "lobby");
                            window.location.reload();
                        }
                    });
                }
            })
            loaded = true;
         }else if(screenChanger) {

            if(screenChanger.current){
                screenChanger.current.setBlockchainInfos(blockchaininfos);
                screenChanger.current.setUserInfos(gUserInfos, props.gameConfig);
            }
                
         }

         if(!screenChanger)
            return;
        
        window.addEventListener('keydown', onKeyDown);
        window.addEventListener('keyup', onKeyUp);

        window.addEventListener('resize', function () {

        if(glDomRef.current != null)
            curEngine.resizeCanvasToDisplaySize(glDomRef.current.offsetWidth, glDomRef.current.offsetHeight);
        })

  return (
        <div className="container-fluid p-0 m-0" id="main-div">
            
            <NavBarBalance setBCInfos={setBCInfos} activeLinks={activeLinks} screenChanger={screenChanger} blockchaininfos={blockchaininfos} userInfos ={gUserInfos} />
            <GameStatsTable totalBonus={totalBonus} stats={gameStats} ></GameStatsTable>

            <div id="gl-dom"
            
                onMouseMove = { (e) => onMouseMove(e)}
                onMouseDown = { (e) => onMouseDown(e)}
                onMouseUp = { (e) => onMouseUp(e)}
                onTouchStart = { (e) => onTouchStart(e)}
                onTouchMove = { (e) => onTouchMove(e)}
                onTouchEnd = { (e) => onTouchEnd(e)}

                ref={glDomRef}>

            </div>
        </div>
        
  );
}


export default GameGL;
